document.addEventListener('click', function (event) {
  const target = event.target.closest('.c-ripple'); // Check if the clicked element or its parent has the c-ripple class

  if (!target) return;

  // Create a ripple element
  const ripple = document.createElement('span');

  // Get the position and size of the clicked element
  const rect = target.getBoundingClientRect();
  const size = Math.max(rect.width, rect.height);
  const x = event.clientX - rect.left - size / 2;
  const y = event.clientY - rect.top - size / 2;

  // Style the ripple
  ripple.style.position = 'absolute';
  ripple.style.width = `${size}px`;
  ripple.style.height = `${size}px`;
  ripple.style.left = `${x}px`;
  ripple.style.top = `${y}px`;
  ripple.style.borderRadius = '50%';
  ripple.style.background = 'rgba(255, 255, 255, 0.3)';
  ripple.style.transform = 'scale(0)';
  ripple.style.opacity = '1';
  ripple.style.animation = 'ripple-effect 600ms ease-out';
  ripple.style.pointerEvents = 'none';

  // Add the ripple to the target button
  target.style.position = 'relative'; // Ensure the target button has relative positioning
  target.style.overflow = 'hidden';
  target.appendChild(ripple);

  // Check if the button is a link
  const link = target.closest('a');
  if (link) {
    event.preventDefault(); // Prevent immediate navigation

    // Wait for the ripple effect to finish before navigating
    ripple.addEventListener('animationend', () => {
      window.location.href = link.href;
    });
  }

  // Remove the ripple after the animation
  ripple.addEventListener('animationend', () => {
    ripple.remove();
  });
});